export const makeTextsHighlighted = function (element, termSearched) {
  const textBlocks = element.getElementsByClassName('chakra-text')
  for (let text of textBlocks) {
    text.innerHTML = text.innerText.replace(
      termSearched,
      `<span style="background-color: yellow">${termSearched}</span>`,
    )
  }
}
